import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
} from '@angular/core';
import { FileService } from '../../services/file.service';

@Component({
  selector: 'app-upload-file',
  templateUrl: './drag-drop-file-input.component.html',
  styleUrls: ['./drag-drop-file-input.component.css'],
  standalone: false,
})
export class DragDropFileInputComponent {
  constructor(private fileService: FileService) {}

  @ViewChild('fileInput', { static: true }) fileInput: any;
  @Output() getFile = new EventEmitter<File>();
  @Output() getFiles = new EventEmitter<Array<File>>();
  // TODO: Add validator
  @Input() validExtensions: string[];
  @Input() maxSizeMb: number;
  @Input() infoText: string;
  @Input() additionalInfo: string;
  @Input() fileNameInfo: string;
  @Input() selectMultiple: boolean = false;
  private files: Array<File> = [];

  uploadFile(event: FileList): void {
    var errors = null;
    this.uploadFiles(event);
    if (!this.selectMultiple) {
      errors = this.fileService.validateExtensionsAndMaximumAllowedSize(
        this.files[0],
        this.validExtensions,
        this.maxSizeMb,
      );
    }
    if (errors) {
      this.files = [];
    } else {
      this.getFile.next(this.files[0]);
      this.getFiles.next(this.files);
    }
  }

  uploadFiles(event: FileList): void {
    if (event[0] != null) {
      this.files = [];
      for (let i = 0; i < event.length; i++) {
        this.files.push(event[i]);
      }
    }
  }

  selectFile(): void {
    this.fileInput.nativeElement.value = null;
    this.fileInput.nativeElement.click();
  }
}
